module.exports = __webpack_public_path__ + "media/images/lb/738-1dcd3c19a72ef509c9b6963bced10d76.svg";